import {IPromise} from "angular";

export class SaveDialog {
  open(factory: () => IPromise<any>): Promise<void> {
    return Promise.resolve();
  }
}